<template>
  <div class="b2b_button" @click="click" :class="disabled ? 'disabled' : ''">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click () {
      if (!this.disabled) {
        this.$emit('click')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.b2b_button {
  overflow: hidden;
  position: relative;
  transition: background-color 0.3s linear, border 0.3s linear;
  width: 100%;
  height: 50px;
  line-height: 50px;
  color: #fff;
  background-color: #1e50f0;
  text-align: center;
  cursor: pointer;
  border-radius: 3px;
  font-family: '微软雅黑';
  display: inline-block;
  font-size: 15px;
  transition: all .2s ease-in;
  user-select: none;

  &:after {
    content: "";
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    pointer-events: none;
    background-image: radial-gradient(circle,
    #000 10%,
    rgba(0, 0, 0, 0) 10.01%);
    background-repeat: no-repeat;
    background-position: 50%;
    transform: scale(10);
    opacity: 0;
    transition: transform 0.5s, opacity 1s;
  }

  &:active:after {
    transform: scale(0);
    opacity: 0.2;
    transition: 0s;
  }

  &:hover {
    opacity: .95;
  }

  &.disabled {
    color: rgb(255, 255, 255);
    background-color: rgb(200, 201, 204);
    border-color: rgb(200, 201, 204);
    cursor: not-allowed;

    &:hover {
      opacity: 1;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/newPages/components/B2B_button.vue